module.exports = __webpack_public_path__ + "img/offer-support.98f155ee.svg";